import type {SelectOptionItem} from '@yandex-delivery/blocks'
import {i18n} from 'src/shared/config'

export const options: SelectOptionItem[] = [
  {
    value: i18n('profile.form.segment.options.auto_products', 'Автотовары'),
    label: i18n('profile.form.segment.options.auto_products', 'Автотовары'),
  },
  {
    value: i18n(
      'profile.form.segment.options.ready_meals_and_cooking',
      'Готовые блюда и кулинария',
    ),
    label: i18n(
      'profile.form.segment.options.ready_meals_and_cooking',
      'Готовые блюда и кулинария',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.children_goods',
      'Детские товары',
    ),
    label: i18n(
      'profile.form.segment.options.children_goods',
      'Детские товары',
    ),
  },
  {
    value: i18n('profile.form.segment.options.documents', 'Документы'),
    label: i18n('profile.form.segment.options.documents', 'Документы'),
  },
  {
    value: i18n(
      'profile.form.segment.options.cosmetics_and_perfumes',
      'Косметика и парфюмерия',
    ),
    label: i18n(
      'profile.form.segment.options.cosmetics_and_perfumes',
      'Косметика и парфюмерия',
    ),
  },
  {
    value: i18n('profile.form.segment.options.furniture', 'Мебель'),
    label: i18n('profile.form.segment.options.furniture', 'Мебель'),
  },
  {
    value: i18n(
      'profile.form.segment.options.medical_products',
      'Медицинские товары',
    ),
    label: i18n(
      'profile.form.segment.options.medical_products',
      'Медицинские товары',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.clothing_and_accessories',
      'Одежда и аксессуары',
    ),
    label: i18n(
      'profile.form.segment.options.clothing_and_accessories',
      'Одежда и аксессуары',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.sporting_products',
      'Спорттовары',
    ),
    label: i18n(
      'profile.form.segment.options.sporting_products',
      'Спорттовары',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.construction_products',
      'Строительные товары',
    ),
    label: i18n(
      'profile.form.segment.options.construction_products',
      'Строительные товары',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.household_goods',
      'Товары для дома',
    ),
    label: i18n(
      'profile.form.segment.options.household_goods',
      'Товары для дома',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.leisure_and_hobby_products',
      'Товары для досуга и хобби',
    ),
    label: i18n(
      'profile.form.segment.options.leisure_and_hobby_products',
      'Товары для досуга и хобби',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.pet_supplies',
      'Товары для животных',
    ),
    label: i18n(
      'profile.form.segment.options.pet_supplies',
      'Товары для животных',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.goods_for_holidays',
      'Товары для праздника',
    ),
    label: i18n(
      'profile.form.segment.options.goods_for_holidays',
      'Товары для праздника',
    ),
  },
  {
    value: i18n(
      'profile.form.segment.options.everyday_products',
      'Товары повседневного спроса (продукты питания, напитки, бытовая химия)',
    ),
    label: i18n(
      'profile.form.segment.options.everyday_products',
      'Товары повседневного спроса (продукты питания, напитки, бытовая химия)',
    ),
  },
  {
    value: i18n('profile.form.segment.options.flowers', 'Цветы'),
    label: i18n('profile.form.segment.options.flowers', 'Цветы'),
  },
  {
    value: i18n(
      'profile.form.segment.options.electronics_and_household_appliances',
      'Электроника и бытовая техника',
    ),
    label: i18n(
      'profile.form.segment.options.electronics_and_household_appliances',
      'Электроника и бытовая техника',
    ),
  },
  {
    value: i18n('profile.form.segment.options.other', 'Другие товары'),
    label: i18n('profile.form.segment.options.other', 'Другие товары'),
  },
]

export const fallbackOption: SelectOptionItem = {
  value: i18n('profile.form.segment.options.other', 'Другие товары'),
  label: i18n('profile.form.segment.options.other', 'Другие товары'),
}
